import React from 'react';
import { FaShieldAlt, FaHandshake, FaUsers, FaMapMarkerAlt, FaGraduationCap, FaHome, FaFileAlt, FaEuroSign, FaRocket, FaStar } from 'react-icons/fa';
import heroImage from '../../assets/images/16256199_June83-removebg-preview.png';
import './CompanyPresentation.css';

const CompanyPresentation = () => {
  const values = [
    {
      icon: <FaShieldAlt />,
      title: "Confiance & Sécurité",
      description: "Votre réussite est notre priorité absolue"
    },
    {
      icon: <FaHandshake />,
      title: "Accompagnement personnalisé",
      description: "Un suivi individualisé à chaque étape"
    },
    {
      icon: <FaUsers />,
      title: "Expertise Collective",
      description: "Une équipe expérimentée à votre service"
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Intégration facile",
      description: "Nous vous aidons à vous installer en France"
    }
  ];

  const services = [
    {
      icon: <FaGraduationCap />,
      title: "Admission ",
      description: "Le choix et l'admission dans les établissements français",
      color: '#073b8f'
    },
    {
      icon: <FaHome />,
      title: "Logement ",
      description: "La recherche et la réservation de logement étudiant",
      color: '#c0264a'
    },
    {
      icon: <FaFileAlt />,
      title: "Dossier de visa",
      description: "La préparation complète du dossier de visa",
      color: '#073b8f'
    },
    {
      icon: <FaEuroSign />,
      title: "Attestation AVI",
      description: "L'obtention de l'Attestation de Virement Irrévocable (AVI)",
      color: '#c0264a'
    }
  ];

  return (
    <section className="btg-company-presentation-light" id="btg-company">
      <div className="btg-container-light">
        {/* En-tête de section - Style clair premium */}
        <div className="btg-company-header-light">
          <div className="btg-header-content-light">
            <div className="btg-header-badge">
              <FaRocket className="btg-badge-icon" />
              <span>BTG CONSEIL</span>
            </div>
            <h1 className="btg-main-title-light">Votre partenaire de confiance</h1>
            <p className="btg-main-subtitle-light">Spécialistes de l'accompagnement des étudiants</p>
            <p className="btg-section-subtitle-light">
              Nous transformons les rêves d'études en France en réalités tangibles grâce à notre expertise et notre accompagnement personnalisé
            </p>
            <div className="btg-header-decoration-light">
              <div className="btg-decoration-line-light"></div>
              <div className="btg-decoration-dot-light"></div>
              <div className="btg-decoration-glow-light"></div>
              <div className="btg-decoration-dot-light"></div>
              <div className="btg-decoration-line-light"></div>
            </div>
          </div>
        </div>

        {/* Section services horizontaux clair */}
        <div className="btg-services-horizontal-light">
          <div className="btg-services-wrapper-light">
            <h2 className="btg-services-main-title-light">Nos domaines d'expertise</h2>
            <div className="btg-services-cards-grid-light">
              {services.map((service, index) => (
                <div 
                  key={index} 
                  className="btg-service-horizontal-card-light"
                  style={{ '--btg-accent-color': service.color }}
                >
                  <div className="btg-card-glow" style={{ '--glow-color': service.color }}></div>
                  
                  <div className="btg-service-horizontal-content-light">
                    <div className="btg-service-icon-container-light">
                      <div className="btg-service-main-icon-light">
                        {service.icon}
                      </div>
                      <div className="btg-icon-glow"></div>
                    </div>
                    <h3 className="btg-service-card-title-light">{service.title}</h3>
                    <p className="btg-service-card-description-light">{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="btg-main-content-grid-light">
          {/* Text Content */}
          <div className="btg-content-left-light">
            <div className="btg-mission-card-light">
              <div className="btg-card-header-light">
                <div className="btg-icon-wrapper btg-mission-icon-light">
                  <FaGraduationCap />
                </div>
                <h2>Notre mission</h2>
              </div>
              <p>
                Chez <strong>BTG CONSEIL</strong>, nous transformons les rêves d'études en France 
                en réalités tangibles. Notre équipe dévouée vous guide à travers chaque étape 
                de votre projet académique, de la conception à la concrétisation.
              </p>
            </div>

            <div className="btg-expertise-card-light">
              <div className="btg-card-header-light">
                <div className="btg-icon-wrapper btg-expertise-icon-light">
                  <FaUsers />
                </div>
                <h2>Notre expertise</h2>
              </div>
              <p>
                Forts de notre connaissance approfondie du système éducatif français 
                et des procédures administratives, nous vous offrons un accompagnement 
                sur mesure pour réussir votre intégration en France.
              </p>
            </div>
          </div>

          {/* Image Section */}
          <div className="btg-content-right-light">
            <div className="btg-image-container-light">
              <div className="btg-main-image-wrapper-light">
                <img 
                  src={heroImage}
                  alt="Étudiants BTG CONSEIL en France"
                  className="btg-main-image-light"
                />
                <div className="btg-image-overlay-light"></div>
                <div className="btg-floating-badge-light">
                  <span>+500</span>
                  <small>Étudiants accompagnés</small>
                </div>
              </div>
              
              {/* Image Stats */}
              <div className="btg-image-stats-light">
                <div className="btg-stat-item-light">
                  <div className="btg-stat-number-light">98%</div>
                  <div className="btg-stat-label-light">Taux de réussite</div>
                </div>
                <div className="btg-stat-item-light">
                  <div className="btg-stat-number-light">50+</div>
                  <div className="btg-stat-label-light">Universités partenaires</div>
                </div>
                <div className="btg-stat-item-light">
                  <div className="btg-stat-number-light">24h</div>
                  <div className="btg-stat-label-light">Support rapide</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="btg-values-section-light">
          <div className="btg-values-header-light">
            <div className="btg-values-header-content-light">
              <h2 className="btg-values-main-title-light">Nos valeurs</h2>
              <p className="btg-values-subtitle-light">Ce qui fait notre différence</p>
              <div className="btg-values-header-decoration-light">
                <div className="btg-values-decoration-line-light"></div>
                <div className="btg-values-decoration-dot-light"></div>
                <div className="btg-values-decoration-line-light"></div>
              </div>
            </div>
          </div>
          <div className="btg-values-grid-light">
            {values.map((value, index) => (
              <div key={index} className="btg-value-card-light">
                <div className="btg-value-icon-wrapper-light">
                  {value.icon}
                </div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="btg-company-cta-light">
          <div className="btg-cta-content-light">
            <div className="btg-cta-header-light">
              <h3 className="btg-cta-title-light">Prêt à commencer votre aventure en France ?</h3>
              <p className="btg-cta-subtitle-light">Rejoignez les centaines d'étudiants qui nous font confiance</p>
            </div>
            <p className="btg-cta-text-light">
              Votre avenir en France commence ici. Notre équipe d'experts vous accompagne à chaque étape de votre projet.
            </p>
            <button className="btg-cta-button-light">
              <FaRocket className="btg-cta-icon" />
              Commencer maintenant
              <div className="btg-button-glow"></div>
            </button>
            
            <div className="btg-cta-stats-light">
              <div className="btg-stat-light">
                <div className="btg-stat-number-light">500+</div>
                <div className="btg-stat-label-light">Étudiants accompagnés</div>
              </div>
              <div className="btg-stat-light">
                <div className="btg-stat-number-light">95%</div>
                <div className="btg-stat-label-light">Taux de réussite</div>
              </div>
              <div className="btg-stat-light">
                <div className="btg-stat-number-light">98%</div>
                <div className="btg-stat-label-light">Satisfaction</div>
              </div>
            </div>
          </div>
          
          {/* Background animé pour le CTA */}
          <div className="btg-cta-background-light">
            <div className="btg-cta-particle"></div>
            <div className="btg-cta-particle"></div>
            <div className="btg-cta-particle"></div>
          </div>
        </div>
      </div>

      {/* Background éléments décoratifs */}
      <div className="btg-background-elements">
        <div className="btg-bg-element btg-bg-1"></div>
        <div className="btg-bg-element btg-bg-2"></div>
        <div className="btg-bg-element btg-bg-3"></div>
        <div className="btg-bg-element btg-bg-4"></div>
      </div>
    </section>
  );
};

export default CompanyPresentation;